<template>
  <v-container fluid>
    <v-row>
      <v-col v-for="(item, index) in items" :key="index" sm="3">
        <v-card>
          <v-card-title>{{ item.name }}</v-card-title>
          <v-card-text>
            <v-btn icon @click="editItem(item)"
              ><v-icon>mdi-pencil</v-icon></v-btn
            >
            <v-btn icon @click="askDeleteTemplate(item)"
              ><v-icon>mdi-delete</v-icon></v-btn
            >
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "TemplateCardList",
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  data: () => ({}),
  components: {},
  methods: {
    askDeleteTemplate(item) {
      this.$emit("deleteItem", item);
    },
    editItem(item) {
      this.$emit("editItem", item);
    }
  },

  computed: {},

  created() {}
};
</script>

<style scoped>
#Gerichtlistcard {
  margin: 20px;
}
</style>
